import { EnvironmentInterface } from '../app/core/models/environment.interface';

export const environment: EnvironmentInterface = {
  production: true,
  apiUrl: '',
  apiMulesoftSuffix: '/api/v1',
  appUrl: '',
  appApiUrl: '',
  providers: []
};
